export const WEBAPP_SENDEMAIL_ADDTOEMAIL = 'WEBAPP_SENDEMAIL_ADDTOEMAIL';
export const WEBAPP_SENDEMAIL_ADDCCEMAIL = 'WEBAPP_SENDEMAIL_ADDCCEMAIL';
export const WEBAPP_SENDEMAIL_ADDBCCEMAIL = 'WEBAPP_SENDEMAIL_ADDBCCEMAIL';
export const WEBAPP_SENDEMAIL_DELETETOEMAIL = 'WEBAPP_SENDEMAIL_DELETETOEMAIL';
export const WEBAPP_SENDEMAIL_DELETECCEMAIL = 'WEBAPP_SENDEMAIL_DELETECCEMAIL';
export const WEBAPP_SENDEMAIL_DELETEBCCEMAIL =
  'WEBAPP_SENDEMAIL_DELETEBCCEMAIL';
export const WEBAPP_SENDEMAIL_CLICKEDSUBJECT =
  'WEBAPP_SENDEMAIL_CLICKEDSUBJECT';
export const WEBAPP_SENDEMAIL_CLICKEDEMAILCONTENT =
  'WEBAPP_SENDEMAIL_CLICKEDEMAILCONTENT';
export const WEBAPP_SENDEMAIL_ADDATTACHMENT = 'WEBAPP_SENDEMAIL_ADDATTACHMENT';
export const WEBAPP_SENDEMAIL_REMOVEATTACHMENT =
  'WEBAPP_SENDEMAIL_REMOVEATTACHMENT';
export const WEBAPP_SENDEMAIL_TOGGLESAVEASTEMPLETEON =
  'WEBAPP_SENDEMAIL_TOGGLESAVEASTEMPLETEON';
export const WEBAPP_SENDEMAIL_TOGGLESAVEASTEMPLETEOFF =
  'WEBAPP_SENDEMAIL_TOGGLESAVEASTEMPLETEOFF';
export const WEBAPP_SENDEMAIL_TOGGLETRACKEMAILON =
  'WEBAPP_SENDEMAIL_TOGGLETRACKEMAILON';
export const WEBAPP_SENDEMAIL_TOGGLETRACKEMAILOFF =
  'WEBAPP_SENDEMAIL_TOGGLETRACKEMAILOFF';
export const WEBAPP_SENDEMAIL_CLICKEDSENDMETESTEMAIL =
  'WEBAPP_SENDEMAIL_CLICKEDSENDMETESTEMAIL';
export const WEBAPP_SENDEMAIL_CLICKEDSUBMITEMAIL =
  'WEBAPP_SENDEMAIL_CLICKEDSUBMITEMAIL';
export const WEBAPP_SENDEMAIL_CLICKEDCLOSEEMAILMODAL =
  'WEBAPP_SENDEMAIL_CLICKEDCLOSEEMAILMODAL';
export const WEBAPP_SENDEMAIL_TOGGLEBOLD = 'WEBAPP_SENDEMAIL_TOGGLEBOLD';
export const WEBAPP_SENDEMAIL_TOGGLEITALIC = 'WEBAPP_SENDEMAIL_TOGGLEITALIC';
export const WEBAPP_SENDEMAIL_TOGGLEUNDERLINE =
  'WEBAPP_SENDEMAIL_TOGGLEUNDERLINE';
export const WEBAPP_SENDEMAIL_ADDVARIABLE = 'WEBAPP_SENDEMAIL_ADDVARIABLE';

export const WEBAPP_SENDEMAIL_CLICKEDATTACHFILE =
  'WEBAPP_SENDEMAIL_CLICKEDATTACHFILE';
export const WEBAPP_SENDEMAIL_ATTACHEDFILE = 'WEBAPP_SENDEMAIL_ATTACHEDFILE';
export const WEBAPP_SENDEMAIL_ATTACHEDTOOMANY =
  'WEBAPP_SENDEMAIL_ATTACHEDTOOMANY';

// peppol

export const WEBAPP_SENDINVOICE_TOGGLEDPEPPOL =
  'WEBAPP_SENDINVOICE_TOGGLEDPEPPOL';
export const WEBAPP_SENDINVOICE_TOGGLEDEMAIL =
  'WEBAPP_SENDINVOICE_TOGGLEDEMAIL';
